import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/utils/cn'

export const DASHBOARD_TIME_TABLE_PAGE_SIZE = 50

export function paginateRows<T>(rows: T[], page: number, pageSize = DASHBOARD_TIME_TABLE_PAGE_SIZE) {
  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize))
  const safePage = Math.min(Math.max(1, page), totalPages)
  const start = (safePage - 1) * pageSize
  return {
    page: safePage,
    totalPages,
    rows: rows.slice(start, start + pageSize),
    from: rows.length === 0 ? 0 : start + 1,
    to: Math.min(start + pageSize, rows.length),
    total: rows.length,
  }
}

type Props = {
  page: number
  totalPages: number
  from: number
  to: number
  total: number
  onPageChange: (page: number) => void
}

export function GestorDashboardTablePagination({
  page,
  totalPages,
  from,
  to,
  total,
  onPageChange,
}: Props) {
  if (total <= DASHBOARD_TIME_TABLE_PAGE_SIZE) return null

  return (
    <div className='flex flex-wrap items-center justify-between gap-3 border-t border-[var(--glass-border)] px-4 py-3'>
      <span className='text-xs text-text-muted'>
        {from}–{to} de {total} registros
      </span>
      <div className='flex items-center gap-2'>
        <button
          type='button'
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className={cn(
            'inline-flex h-8 w-8 items-center justify-center rounded-md transition-colors',
            page <= 1
              ? 'cursor-not-allowed text-text-muted/40'
              : 'text-text-muted hover:bg-white/[0.06] hover:text-text-primary',
          )}
          aria-label='Página anterior'
        >
          <ChevronLeft size={14} />
        </button>
        <span className='min-w-[5rem] text-center text-xs tabular-nums text-text-secondary'>
          {page} / {totalPages}
        </span>
        <button
          type='button'
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className={cn(
            'inline-flex h-8 w-8 items-center justify-center rounded-md transition-colors',
            page >= totalPages
              ? 'cursor-not-allowed text-text-muted/40'
              : 'text-text-muted hover:bg-white/[0.06] hover:text-text-primary',
          )}
          aria-label='Próxima página'
        >
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  )
}
